<template>
  <div @mouseover="hovered = true" @mouseleave="hovered = false">
    <iframe
      :src="src"
      class="video-vimeo netflix-doLoop"
      :id="`player-${videoID}?share=copy`"
      :data-id="`${videoID}?share=copy`"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
      allowfullscreen=""
      frameborder="0"
      :style="styles"
      data-ready="true"
    ></iframe>
    <background-player-controls
      @play-pause="playOrPause"
      @mute-sound="muteOrSound"
      :videoState="videoState"
      :soundState="soundState"
      :mini-player="miniPlayer"
    />
    <bg-thumbnail v-if="videoInfo" :url="videoInfo.thumbnail_large" />
    <button
      v-if="miniPlayer && hovered"
      type="button"
      class="btn btn-mini-player p-0 m-0"
      @click="playOrPause"
    >
      <i :class="ICON_MAP[videoState]"></i>
    </button>
  </div>
</template>
<script>
import BackgroundPlayerControls from "@/components/preview/BackgroundPlayerControls.vue";
import BgThumbnail from "@/components/preview/BgThumbnail.vue";
import { vimeoParser } from "@/functions/helpers";

export default {
  components: { BackgroundPlayerControls, BgThumbnail },
  props: {
    url: {
      type: String,
      default: ""
    },
    miniPlayer: {
      type: Boolean,
      default: false
    },
    size: {
      type: Object,
      default: () => ({ height: 550, width: window.innerWidth })
    }
  },
  data() {
    return {
      player: null,
      iframe: null,
      videoInfo: null,
      hovered: true,
      width: this.size.width,
      height: this.size.height,
      soundState: "muted",
      videoState: "paused"
    };
  },
  computed: {
    ICON_MAP() {
      return {
        paused: "icon-play1",
        ended: "icon-play1",
        playing: "icon-pause2"
      };
    },
    videoID() {
      return vimeoParser(this.url);
    },
    src() {
      return `https://player.vimeo.com/video/${this.videoID}?share=copy&controls=0&autoplay=1&loop=1&title=0&byline=0&portrait=0&background=1&muted=0`;
    },
    styles() {
      return { width: `${this.width}px`, height: `${this.height}px` };
    }
  },
  mounted() {
    this.iframe = document.querySelector("iframe");
    this.player = new Vimeo.Player(this.iframe);

    this.player.on("play", play => {
      this.videoState = "playing";
      document.querySelector(".bg-thumbnail").style.opacity = 0;
      this.hovered = false;
    });

    this.player.on("pause", data => {
      this.videoState = "paused";
    });

    this.player.on("volumechange", data => {
      this.soundState = data.volume == 0 ? "muted" : "sound";
    });

    fetch(`https://vimeo.com/api/v2/video/${this.videoID}.json`)
      .then(resp => resp.json())
      .then(data => {
        if (data) {
          this.videoInfo = data[0];
        }
      });
  },
  methods: {
    playOrPause() {
      if (this.videoState == "paused") {
        this.player.play().then();
      } else {
        this.player.pause().then();
      }
    },
    muteOrSound() {
      if (this.soundState == "muted") {
        this.player.setVolume(1).then();
      } else {
        this.player.setVolume(0).then();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
iframe {
  overflow-clip-margin: content-box !important;
  overflow: clip !important;
  border-width: none;
  border-style: inset;
  border-color: initial;
  border-image: initial;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.bg-thumbnail {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;

  background-color: #000;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;

  transition: opacity 3s ease-in-out;
}
</style>
